import * as type from './type'
import { get, post } from '../../../../util/api'
import * as selector from './selector'
import { createValidationMessage } from '../../../validation/create-validation-message'

export const findAllUserRequest = () => ({
    type: type.FIND_ALL_USER_REQUEST,
})

export const findAllUserSuccess = (userList) => ({
    type: type.FIND_ALL_USER_SUCCESS,
    payload: {
        userList,
    },
})

export const findAllUserError = (error) => ({
    type: type.FIND_ALL_USER_ERROR,
    payload: {
        error,
    },
})

export const findAllUser = () => (dispatch, getState) => {
    dispatch(findAllUserRequest())

    get('/api/security/user/find-employee-external')
        .then((userList) => {
            dispatch(findAllUserSuccess(userList))
        })
        .catch(error => {
            dispatch(findAllUserError(error))
        })
}

export const changeCurrentUserId = (name, currentUserId) => ({
    type: type.CHANGE_CURRENT_USER_ID,
    payload: {
        currentUserId,
    },
})

export const changeUser = (name, value) => ({
    type: type.CHANGE_USER,
    payload: {
        name,
        value,
    },
})

export const changeExternalUser = (name, value) => ({
    type: type.CHANGE_EXTERNAL_USER,
    payload: {
        name,
        value,
    },
})

export const toggleRole = (role, active) => ({
    type: type.TOGGLE_ROLE,
    payload: {
        role,
        active,
    },
})

export const toggleWidgetAccess = (widgetId, active) => ({
    type: type.TOGGLE_WIDGET_ACCESS,
    payload: {
        widgetId,
        active,
    },
})

export const createEmployee = () => ({
    type: type.CREATE_EMPLOYEE,
})

export const createExternalUser = () => ({
    type: type.CREATE_EXTERNAL_USER,
})

export const saveUserRequest = () => ({
    type: type.SAVE_USER_REQUEST,
})

export const saveUserSuccess = (currentUser) => ({
    type: type.SAVE_USER_SUCCESS,
    payload: {
        currentUser,
    },
})

export const saveUserError = (error) => ({
    type: type.SAVE_USER_ERROR,
    payload: {
        error,
    },
})

export const saveUser = () => (dispatch, getState) => {
    const state = getState()
    const hasChanged = selector.selectHasChanged(state)
    const user = selector.selectCurrentUser(state)

    if (!hasChanged || !user.id) {
        return
    }

    dispatch(saveUserRequest())

    post('/api/security/user/save', user)
        .then((user) => {
            dispatch(saveUserSuccess(user))
        })
        .catch(error => {
            dispatch(saveUserError(error))
        })
}

export const generateNewPassworRequest = () => ({
    type: type.GENERATE_NEW_PASSWORD_REQUEST,
})

export const generateNewPasswordSuccess = (currentUser) => ({
    type: type.GENERATE_NEW_PASSWORD_SUCCESS,
    payload: {
        currentUser,
    },
})

export const generateNewPasswordError = (error) => ({
    type: type.GENERATE_NEW_PASSWORD_ERROR,
    payload: {
        error,
    },
})

export const generateNewPassword = () => (dispatch, getState) => {
    const state = getState()
    const userId = selector.selectCurrentUserId(state)

    if (!userId) {
        return
    }

    dispatch(generateNewPassworRequest())

    get('/api/security/user/generate-new-password?userId=' + userId)
        .then((user) => {
            dispatch(generateNewPasswordSuccess(user))
        })
        .catch(error => {
            dispatch(generateNewPasswordError(error))
        })
}

export const validateUser = (user) => {
    const validationMessageList = []

    if (!user.gender) {
        validationMessageList.push(createValidationMessage('Salutation is mandatory', 'salutation'))
    }

    if (!user.firstName) {
        validationMessageList.push(createValidationMessage('Firstname is mandatory', 'firstName'))
    }

    if (!user.lastName) {
        validationMessageList.push(createValidationMessage('Lastname is mandatory', 'lastName'))
    }

    if (!user.email) {
        validationMessageList.push(createValidationMessage('Email is mandatory', 'email'))
    }

    if (user.externalUser && !user.externalUser.partnerId) {
        validationMessageList.push(createValidationMessage('Partner is mandatory', 'partner'))
    }
    return validationMessageList
}


export const setUserValidationResult = (validationMessageList) => ({
    type: type.SET_USER_VALIDATION_RESULT,
    payload: {
        validationMessageList,
    },
})

export const createUserRequest = () => ({
    type: type.CREATE_USER_REQUEST,
})

export const createUserSuccess = (currentUser) => ({
    type: type.CREATE_USER_SUCCESS,
    payload: {
        currentUser,
    },
})

export const createUserError = (error) => ({
    type: type.CREATE_USER_ERROR,
    payload: {
        error,
    },
})

export const createUser = () => (dispatch, getState) => {
    const state = getState()
    const user = selector.selectCurrentUser(state)

    const validationResult = validateUser(user)
    if (validationResult.length !== 0) {
        dispatch(setUserValidationResult(validationResult))
        return
    }
    dispatch(createUserRequest())

    post('/api/security/user/create-employee-or-external-user', user)
        .then(currentUser => {
            dispatch(createUserSuccess(currentUser))
        })
        .catch(error => {
            dispatch(createUserError(error))
        })
}

export const findAllRoleRequest = () => ({
    type: type.FIND_ALL_ROLE_REQUEST,
})

export const findAllRoleSuccess = (roleList) => ({
    type: type.FIND_ALL_ROLE_SUCCESS,
    payload: {
        roleList,
    },
})

export const findAllRoleError = (error) => ({
    type: type.FIND_ALL_ROLE_ERROR,
    payload: {
        error,
    },
})

export const findAllRole = () => (dispatch, getState) => {
    dispatch(findAllRoleRequest())

    get('/api/security/role/find-all')
        .then((roleList) => {
            dispatch(findAllRoleSuccess(roleList))
        })
        .catch(error => {
            dispatch(findAllRoleError(error))
        })
}

export const changeCurrentRoleId = (name, currentRoleId) => ({
    type: type.CHANGE_CURRENT_ROLE_ID,
    payload: {
        currentRoleId,
    },
})

export const saveRoleRequest = () => ({
    type: type.SAVE_ROLE_REQUEST,
})

export const saveRoleSuccess = (currentRole) => ({
    type: type.SAVE_ROLE_SUCCESS,
    payload: {
        currentRole,
    },
})

export const saveRoleError = (error) => ({
    type: type.SAVE_ROLE_ERROR,
    payload: {
        error,
    },
})

export const saveRole = () => (dispatch, getState) => {
    const state = getState()
    const hasChanged = selector.selectHasChanged(state)
    const role = selector.selectCurrentRole(state)
    if (!hasChanged) {
        return
    }
    dispatch(saveRoleRequest())

    post('/api/security/role/save', role)
        .then((role) => {
            dispatch(saveRoleSuccess(role))
            dispatch(findAllRole())
        })
        .catch(error => {
            dispatch(saveRoleError(error))
        })
}

export const toggleRoleWidgetAccess = (widgetId, active) => ({
    type: type.TOGGLE_ROLE_WIDGET_ACCESS,
    payload: {
        widgetId,
        active,
    },
})



// WEBPACK FOOTER //
// ./src/modules/security/state/manage/action.js